import { orange } from '@mui/material/colors'

interface P {
    children: any
    color?: string
}

function Mark({ children, color }: P) {
    return (
        <mark style={{
            padding: 2,
            borderRadius: 4,
            fontStyle: 'italic',
            backgroundColor: orange[100],
            color: color ?? orange[900],
            fontWeight: 'bold'
        }}>
            {children}
        </mark>
    )
}

export default Mark
